// Core
import React from 'react';

import css from './style.scss';
// import icons from '../../_fonts.scss';
const icons  = {}

const pastWork = [{
  title: 'Oregon Gridiron',
  url: 'http://oregongridiron.com',
  linkText: 'www.oregongridiron.com',
  description: [
    `Site created for University of Oregon Recruiting while employed at Super Top Secret. Built with lead developer Dane Hansen.`, 
    `This site earned a multitude of awards including the Adobe/FWA Cutting Edge Project of the Week, FWA site of the day, Awwards site of the day, and best in show at AAF Utah.`,
    `Front end development and animation.`
  ],
  awards: [
    {
      organization: 'fwa',
      title: 'Site of the Day',
      url: 'http://www.thefwa.com/site/oregon-gridiron'
    },
    {
      organization: 'awwwards',
      title: 'Site of the Day',
      url: 'http://www.awwwards.com/web-design-awards/oregon-gridiron'
    },
    {
      organization: 'cssda',
      title: 'Site of the Day',
      url: 'http://www.cssdesignawards.com/sites/oregon-gridiron/23554/'
    },
    {
      organization: 'csswinner',
      title: 'Site of the Day',
      url: 'http://www.csswinner.com/details/oregon-gridiron/5919'
    },
    {
      organization: 'adobe',
      title: 'Cutting Edge Project of the Week',
      url: 'http://www.thefwa.com/adobe/tcea/oregon-gridiron'
    }
  ]
},
{
  title: 'Super Top Secret',
  // url: 'http://wearetopsecret.com/',
  url: 'http://old.wearetopsecret.com/',
  linkText: 'www.wearetopsecret.com',
  description: [
    `Also known as v3, STS re-imagined their agency and launched this site - showcasing new clients, new work and new capabilities.`,
    `This site was recognized many times over, earning a site of the month from CSS Design awards as well as Site of The Day from FWA, Awwwards, and CSS Winner.`,
    `Responsive Front end development and animation.`
  ],
  awards: [
    {
      organization: 'fwa',
      title: 'Site of the Day',
      url: 'http://www.thefwa.com/site/super-top-secret'
    },
    {
      organization: 'awwwards',
      title: 'Site of the Day',
      url: 'http://www.awwwards.com/web-design-awards/super-top-secret'
    },
    {
      organization: 'cssda',
      title: 'Site of the Month',
      url: 'http://www.cssdesignawards.com/sites/super-top-secret/26694/'
    },
    {
      organization: 'csswinner',
      title: 'Site of the Day',
      url: 'http://www.csswinner.com/details/super-top-secret/9415'
    }
  ]
},
{
  title: 'Marcus Mariota Road to the Heisman',
  // url: 'http://www.mahalomarcus.com',
  // url: 'http://www.wearetopsecret.com/project/39/university-of-oregon/mahalo-marcus-interactive-editorial',
  url: '/mariota/index.html',
  linkText: 'www.mahalomarcus.com',
  description: [
    `Two weeks prior to Mariota hoisting the Heisman Trophy award, University of Oregon decided they needed a polished interactive editorial to celebrate his historic season. Design to launch in 16 days.`,
    `Responsive front end development and animation.`
  ],
  awards: [
    {
      organization: 'awwwards',
      title: 'Honorable Mention',
      url: 'http://www.awwwards.com/best-websites/mahalo-marcus'
    }
  ]
},
// {
//   title: 'Oakley - One Obsession',
//   url: 'http://www.oakley.com/one-obsession',
//   linkText: 'oakley.com/one-obsession',
//   description: [
//     `Site created to accompany their #LiveYours campaign showcasing Oakley athletes who are obsessed with their craft. The site uses an amalgamation of video, social and personal stories to convey athlete passion.`,
//     `Responsive front end development.`
//   ]
// },
// {
//   title: `Nyman's World`,
//   url: 'http://nymansworld.com/',
//   linkText: 'www.nymansworld.com',
//   description: [
//     `Steve Nyman is a Olympic Downhill Skier and member of the US Ski Team. Steve wanted to set himself apart from the rest of the US Ski Team members.`,
//     `After nailing down new sponsorships, Steve is currently competing in the FIS Alpine World Cup.`,
//     `Full design and development. Custom CMS.`
//   ]
// }
]

class Work extends React.Component {

  componentDidMount() {
    this.props.setParentState({ showVideo: false })
  }
  render() {
    const examples = pastWork.map(work => {
      const description = work.description.map(desc => {
        return (<p key={ desc } className={ css.p }>{ desc }</p>)
      })
      let awardsList = null;
      if(work.awards) {
        awardsList = work.awards.map(award => {
          return(
            <li key={ award.url } className={ css.award }>
              <a href={ award.url } target="_blank">
                <img src={ `images/${ award.organization }.png` } alt={ award.title } className={ css.img } />
              </a>
            </li>
          )
        })
      }
      return (
        <li className={ css.work } key={ work.title }>
          <h3 className={ css.h3 }>
            { work.title }
          </h3>
          <h4 className={ css.h4 }>
            <a href={ work.url } target='_blank' className={ css.a }>{ work.linkText } <i className={ `${ icons.iconLinkExt } ${ css.i }` }></i></a><br/>
          </h4>
          <div>
            { description }
          </div>
          <ul className={ css.awardsList }>
            { awardsList }
          </ul>
        </li>
      )
    })

    return (
      <div>
        <article className={ css.Work }>
          <h1 className={ css.h1 }>
            Selected Work
          </h1>
          <p className={ css.p }>
            More examples upon request.
          </p>
          <ul>
            { examples }
          </ul> 
        </article>
        <img src="/images/arrow.jpg" className={ css.sketch } alt="Archery arrow by aaron sather." />
      </div>
    )
  }
}

export default Work;



// WEBPACK FOOTER //
// ./app/js/components/Work/index.js